import apiClient from '../apiClient';
import { normalizeTimeOffRequest } from '../transformers';

export const fetchTimeOffRequests = async () => {
  const response = await apiClient.get('/time-off');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeTimeOffRequest).filter(Boolean);
};

export const fetchMyTimeOffRequests = async () => {
  const response = await apiClient.get('/time-off/mine');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeTimeOffRequest).filter(Boolean);
};

export const createTimeOffRequest = async (payload) => {
  const response = await apiClient.post('/time-off', payload);
  return normalizeTimeOffRequest(response?.data);
};

export const updateTimeOffStatus = async (id, payload) => {
  const response = await apiClient.post(`/time-off/${id}/status`, payload);
  return normalizeTimeOffRequest(response?.data);
};

export default {
  fetchTimeOffRequests,
  fetchMyTimeOffRequests,
  createTimeOffRequest,
  updateTimeOffStatus,
};
